const ConnectingCall = (props) => {

    return (
 <div className="message">Setting up your consultation...</div>
    );
}

export default ConnectingCall;